export function getOneTrustScript(id: string | undefined, isProd = false) {
  if (!id) {
    return '';
  }
  return `
    <!-- OneTrust Cookies Consent Notice start-->
    ${isProd ? `<script type="text/javascript" src="https://cdn.cookielaw.org/consent/${id}/OtAutoBlock.js" ></script>` : ``}
    <script src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js" data-document-language="true" type="text/javascript" charset="UTF-8" data-domain-script="${id}" ></script>
    <script type="text/javascript">function OptanonWrapper() { }</script>
    <!-- OneTrust Cookies Consent Notice end -->
    `;
}

export function getGoogleTagManagerScript(id: string | undefined) {
  if (!id) {
    return '';
  }
  return `
    <!-- Google Tag Manager -->
    <script>(function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
            'gtm.start':
                new Date().getTime(), event: 'gtm.js'
        });
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src =
            'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', '${id}');</script>
    <!-- End Google Tag Manager -->
    `;
}
